<template>
  <div>
    <nav-header style="display: none" v-bind:showSearch="p_showSearch" v-bind:loginModalFlag="p_loginModalFlag" v-on:showLoginModal="p_showLoginModal" v-on:closeLoginModal="p_closeLoginModal"></nav-header>
    <div class="cover" :style="{minHeight: clientHeight}">
      <div class="cover_in">
        <img class="banner banner-phone" src="../../assets/novel-coronavirus/sample-banner.png" alt="">
        <img class="banner banner-pc" src="../../assets/novel-coronavirus/sample-banner-pc.png" alt="">
        <div class="explain">
          <div class="explain_title">
            上传授权同意函：
          </div>
          <div class="explain_content">
            <el-upload
              ref="upload"
              class="upload-demo"
              :action="actionUrl"
              :headers="uploadHeader"
              :multiple="false"
              :before-upload="beforeUploadHandle"
              :on-success="successHandle1"
              :file-list="fileList1">
              <el-button icon="el-icon-upload2" class="btn-base">上传本地文件</el-button>
            </el-upload>
          </div>
          <div class="explain_title">
            上传检测名单：
          </div>
          <div class="explain_content">
            <el-upload
              ref="upload"
              class="upload-demo"
              :action="actionUrl"
              :headers="uploadHeader"
              :multiple="false"
              :before-upload="beforeUploadHandle"
              :on-success="successHandle2"
              :file-list="fileList2">
              <el-button icon="el-icon-upload2" class="btn-base">上传本地文件</el-button>
            </el-upload>
            <div slot="tip" class="el-upload__tip">支持pdf、jpg、gif、png格式；单张大小不超过10M</div>
          </div>
        </div>
        <div class="submit_btn" @click="submit" v-if="list1.length && list2.length">
          <p>提交</p>
        </div>
        <div class="submit_btn disabled" v-else>
          <p>提交</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import NavHeader from "@/components/Header.vue";
  import {getCookie, removeHTMLTag} from "../../util/util"
  import {reqPath} from '../../util/global'

  export default {
    name: "NovelCoronavirusUpload",
    data() {
      return {
        clientHeight: 0,
        p_showSearch: true,
        p_loginModalFlag: false,
        actionUrl: reqPath + `/hpv/upload`,
        uploadHeader: {
          'token': getCookie("_token")
        },
        fileList1: [],
        fileList2: [],
        list1: [],
        list2: []
      }
    },
    computed: {

    },
    watch: {

    },
    components: {
      NavHeader
    },
    mounted() {
      setTimeout(() => {
        this.clientHeight = document.documentElement.clientHeight + 'px'
      }, 100)
      if (getCookie("_token")) {

      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.p_showLoginModal()
      }
    },
    methods: {
      p_showLoginModal () {
        this.p_loginModalFlag = true;
      },

      p_closeLoginModal () {
        this.p_loginModalFlag = false;
      },
      // 上传之前
      beforeUploadHandle (file) {
        if (!file.name.endsWith('pdf') && !file.name.endsWith('jpg') && !file.name.endsWith('gif') && !file.name.endsWith('png')) {
          this.$message.error('只支持pdf、jpg、gif、png格式文件！')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('单张大小不超过10M!')
          return false
        }
      },
      successHandle1 (response, file, fileList) {
        if (response && response.code === 0) {
          this.list1 = fileList
          this.$message({
            message: '上传成功',
            type: 'success',
            duration: 1500
          })
          console.log(this.list1)
        } else {
          this.$message.error(response.msg)
        }
      },
      successHandle2 (response, file, fileList) {
        if (response && response.code === 0) {
          this.list2 = fileList
          this.$message({
            message: '上传成功',
            type: 'success',
            duration: 1500
          })
        } else {
          this.$message.error(response.msg)
        }
      },
      submit () {
        let file1 = []
        this.list1.map((item, index, arr) => {
          file1.push(item.response.url)
        })
        this.list2.map((item, index, arr) => {
          file1.push(item.response.url)
        })
        let params = {
          companyName: '',
          address: '',
          name: '',
          mobile: '',
          position: '',
          num: '',
          remark: '',
          file1: JSON.stringify(file1)
        }
        axios.post("jys/questionnaire/saveXGFile", params).then((res) => {
          if(res.data.code === 0){
            this.$message({
              message: '提交成功',
              type: 'success',
              duration: 1500
            })
            this.$router.go(-1)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .cover{
    width: 100%;
    float: left;
    background-color: #eff8fd;
  }
  .cover_in{
    width: 100%;
    margin: 0 auto;
  }
  .cover .banner{
    width: 100%;
    float: left;
  }
  .explain{
    width: 100%;
    float: left;
    padding: 20px 40px;
    box-sizing: border-box;
    color: #131313;
    font-size: 13px;
  }
  .explain_title,
  .explain_content{
    width: 100%;
    float: left;
  }
  .explain_title{
    font-weight: bolder;
    padding-left: 10px;
    border-left: 3px solid #6FBBED;
  }
  .explain_content{
    line-height: 20px;
    font-size: 12px;
    padding: 10px 0 25px 13px;
  }
  .submit_btn{
    position: fixed;
    left: 50%;
    bottom: 20px;
    margin-left: -150px;
    width: 300px;
    clear: both;
    background-color: #6fbbed;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    border-radius: 3px;
    cursor: pointer;
  }
  .disabled{
    background-color: #8B8B8B;
  }
  .banner-phone{
    display: block;
  }
  .banner-pc{
    display: none;
  }
  .el-upload__tip{
    margin-top: 30px;
  }
  @media only screen and (min-width: 600px) {
    .banner-phone{
      display: none;
    }
    .banner-pc{
      display: block;
    }
    .cover_in{
      width: 45%;
    }
    .cover_in{
      width: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/activities/novel-coronavirus-upload.vue